import { Component, Inject } from '@angular/core';
// eslint-disable-next-line import/order
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { State, Store } from '@ngrx/store';
import { PaymentAccount } from '@uzurv/clara';
import {
  DeletePaymentAccount,
  EditPaymentAccount,
  CreatePaymentAccount
} from '../../../store/organization-rider/organization-rider.actions';
import { OrganizationRiderState } from '../../../store/organization-rider/organization-rider.reducer';
import { getCardTypes, getSubmittingPaymentAccount } from '../../../store/organization-rider/organization-rider.selectors';

export interface AddEditPaymentAccountDataDialogData {
  paymentAccount: PaymentAccount;
  isEditMode: boolean;
}

@Component({
  selector: 'app-add-edit-payment-account-dialog',
  templateUrl: './add-edit-payment-account-dialog.component.html',
  styleUrls: ['./add-edit-payment-account-dialog.component.scss']
})
export class AddEditPaymentAccountDialogComponent {
  cardTypes$ = this.store$.select(getCardTypes);
  isActionsDisabled$ = this.store$.select(getSubmittingPaymentAccount);

  constructor(
    private dialogRef: MatDialogRef<AddEditPaymentAccountDialogComponent>,
    private store$: Store<State<OrganizationRiderState>>,
    @Inject(MAT_DIALOG_DATA) public data: AddEditPaymentAccountDataDialogData
  ) {}

  handleCancelEditPaymentAccount() {
    this.dialogRef.close();
  }

  handleDeletePaymentAccount(): void {
    this.store$.dispatch(DeletePaymentAccount({ payload: { dialogRef: this.dialogRef, paymentAccount: this.data.paymentAccount } }));
  }

  handleCreatePaymentAccount(paymentAccount: PaymentAccount): void {
    this.store$.dispatch(CreatePaymentAccount({ payload: { dialogRef: this.dialogRef, paymentAccount: paymentAccount } }));
  }

  handleUpdatePaymentAccount(paymentAccount: PaymentAccount) {
    this.store$.dispatch(EditPaymentAccount({ payload: { dialogRef: this.dialogRef, paymentAccount: paymentAccount } }));
  }
}
